import { useNavigate } from 'react-router-dom';
import { homeSeoContent, allGuideArticles } from '@/mocks/seoContent';

export default function GuidesSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(slug);
  };

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-sans font-bold text-foreground-900">
              {homeSeoContent.guidesSectionTitle}{' '}
              <span className="text-primary-600">{homeSeoContent.guidesSectionTitleHighlight}</span>
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              {homeSeoContent.guidesSectionSubtitle}
            </p>
          </div>
          <span className="inline-block px-4 py-1.5 rounded-full bg-foreground-900 text-background-50 text-xs font-semibold whitespace-nowrap">
            {homeSeoContent.guidesSectionTag}
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {allGuideArticles.map((article) => (
            <button
              key={article.slug}
              onClick={() => handleArticleClick(article.slug)}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-foreground-300 transition-all duration-300 cursor-pointer text-left"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 left-2.5">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-semibold uppercase tracking-wide">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-400 flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </span>
                  {article.readingTime}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}